module.exports = __webpack_public_path__ + "4fc204131b6558c58e45da168572f582.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/news/img1_2.jpg
// module id = 367
// module chunks = 0